<ng-container *ngIf="config$ | async as config">
  <ng-container [ngSwitch]="config.triggerModel">
    <ba-btn-trigger *ngSwitchCase="'A'" (trigger)="toggleFlowVisibility(true)"></ba-btn-trigger>
    <ba-btn-trigger *ngSwitchCase="'B'" (trigger)="toggleFlowVisibility(true)" [filled]="false"></ba-btn-trigger>
    <ba-card-trigger *ngSwitchCase="'C'" (trigger)="toggleFlowVisibility(true)"></ba-card-trigger>
  </ng-container>

  <ng-template #content>
    <header
      *ngIf="viewConfig.showTopNav"
      class="top-nav"
      [class.top-nav--no-divider]="!viewConfig.showDivider"
      [class.top-nav--no-sticky]="viewConfig.disableStickyNav"
    >
      <div class="top-nav__content">
        <div *ngIf="viewConfig.showLogo">
          <img [src]="asset('assets/images/ibk-logo.svg')" alt="Interbank" class="top-nav__logo" />
        </div>
        <div>
          <button
            [class.disable-behavior]="!viewConfig.showBackButton"
            (click)="onBackButton(viewConfig.showBackButton)"
            class="ibk-btn ibk-btn--primary ibk-btn--borderless top-nav__back"
          >
            <i class="material-icons icon">arrow_back_ios</i>
            <span class="text">Volver</span>
          </button>
        </div>

        <h2 *ngIf="viewConfig.showTitle" class="top-nav__title">
          {{ viewConfig.titleText }}
        </h2>

        <div>
          <button
            (click)="toggleFlowVisibility(false, config.documentType)"
            class="top-nav__close ibk-btn--primary ibk-btn--borderless"
            *ngIf="viewConfig.showCloseButton"
          >
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>
    </header>

    <main class="content">
      <ng-container *ngIf="config$ | async as config">
        <!-- config.documentType === DocumentType.RUC -->
        <ba-legal-person-container
          *ngIf="validateContaineToShow(config.documentType, DocumentType.RUC)"
          [documentNumber]="getDocumentNumber(config.documentNumber)"
          [documentType]="DocumentType.RUC"
          [legalRepresentantNumber]="getLegalRepresentantNumber(config.legalRepresentant)"
          [ruc]="getRuc(config.companyDocumentNumber)"
          [companyDocumentNumber]="config.companyDocumentNumber"
          (userBlacklisted)="onUserBlacklist()"
          (userMaxAccountsNumber)="onUserMaxAccountsNumber()"
          (viewConfigChange)="onViewConfigChange($event)"
          (processCompleted)="accountCreated.emit($event)"
          (flowCompleted)="onFlowCompleted()"
          (exitFlowCreateAccount)="exitFlowCreateAccount()"
        ></ba-legal-person-container>
        <!-- config.documentType === DocumentType.DNI -->
        <ba-natural-person-container
          *ngIf="validateContaineToShow(config.documentType, DocumentType.DNI)"
          [documentNumber]="getDocumentNumber(config.documentNumber)"
          [documentType]="DocumentType.DNI"
          [companyDocumentNumber]="getCompanyDocumentNumber(config.companyDocumentNumber)"
          (viewConfigChange)="onViewConfigChange($event)"
          (processCompleted)="accountCreated.emit($event)"
          (userBlacklisted)="onUserBlacklist()"
          (userMaxAccountsNumber)="onUserMaxAccountsNumber()"
          (flowCompleted)="onFlowCompleted()"
          (exitFlowCreateAccount)="exitFlowCreateAccount()"
        ></ba-natural-person-container>
      </ng-container>
    </main>
  </ng-template>

  <ibk-modal
    *ngIf="!config.inline"
    [fullscreen]="config.fullscreen"
    hide-close
    min-width="900px"
    (closed)="toggleFlowVisibility(false, config.documentType)"
    [opened]="isFlowActive"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ibk-modal>

  <div *ngIf="config.inline">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</ng-container>
